<div class="links-list">

  <!-- Existing link rows -->
  <div class="link-row"
       *ngFor="let link of request.links"
       [class.z-elevated]="openDropdownId === link.linkedRequest?._id">

    <ng-container *ngIf="linkToDelete !== link; else confirmRow">

      <!-- Relation type pill -->
      <div class="relation-pill"
           *ngIf="canEdit"
           (click)="toggleDropdown(link.linkedRequest?._id); $event.stopPropagation()">
        <span>{{ getLabelForType(link.type) | translate }}</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
        <div class="relation-dropdown" *ngIf="openDropdownId === link.linkedRequest?._id">
          <div class="relation-dropdown-header">{{ 'request_v2.links.link_type' | translate }}</div>
          <div class="relation-option"
               [class.selected]="type.value === link.type"
               *ngFor="let type of linkTypes"
               (click)="onLinkTypeChange(link, type.value); $event.stopPropagation()">
            <span>{{ type.label | translate }}</span>
            <mat-icon *ngIf="type.value === link.type">check</mat-icon>
          </div>
        </div>
      </div>
      <span class="relation-pill readonly" *ngIf="!canEdit">
        {{ getLabelForType(link.type) | translate }}
      </span>

      <!-- Request ID pill -->
      <button
        type="button"
        class="id-pill"
        (click)="openLinkedRequest(link.linkedRequest); $event.stopPropagation()"
        [title]="'Ouvrir ' + link.linkedRequest?.requestId">
        {{ link.linkedRequest?.requestId }}
        <mat-icon class="open-icon">open_in_new</mat-icon>
      </button>

      <!-- Title -->
      <span class="link-title">{{ getLinkTitle(link.linkedRequest) }}</span>

      <!-- Status -->
      <div class="link-status">
        <app-status-select
          *ngIf="canEdit && getTranslatedStatus(link.linkedRequest)"
          [statuses]="getTranslatedStatuses(link.linkedRequest)"
          [currentStatus]="getTranslatedStatus(link.linkedRequest)"
          [requestId]="link.linkedRequest._id"
          (statusChange)="refreshCurrentRequest()">
        </app-status-select>
        <span class="status-badge-ro" *ngIf="!canEdit">
          <span class="status-dot" [style.background-color]="getStatus(link.linkedRequest)?.color || '#ccc'"></span>
          {{ getStatusLabel(getStatus(link.linkedRequest)) }}
        </span>
      </div>

      <!-- Delete -->
      <button
        type="button"
        class="row-delete-btn"
        *ngIf="canEdit"
        (click)="confirmDelete(link); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </button>

    </ng-container>

    <!-- Inline delete confirm -->
    <ng-template #confirmRow>
      <span class="confirm-label">{{ 'request_v2.subtasks.confirm_delete' | translate }}</span>
      <button type="button" class="confirm-yes" (click)="deleteLink()">
        {{ 'request_v2.subtasks.confirm_yes' | translate }}
      </button>
      <button type="button" class="confirm-no" (click)="cancelDelete()">
        {{ 'request_v2.subtasks.confirm_no' | translate }}
      </button>
    </ng-template>

  </div>
</div>

<!-- Add link area -->
<div class="add-link-area" *ngIf="canEdit">

  <button type="button" class="add-link-btn" *ngIf="!isLinking" (click)="startLinking()">
    <mat-icon>add</mat-icon>
    {{ 'request_v2.links.add_link' | translate }}
  </button>

  <div class="link-search" *ngIf="isLinking">
    <div class="search-row">

      <!-- Relation type picker (medium) -->
      <div class="relation-pill-md"
           (click)="toggleDropdown('new'); $event.stopPropagation()">
        <span>{{ getLabelForType(newLinkType) | translate }}</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
        <div class="relation-dropdown" *ngIf="openDropdownId === 'new'">
          <div class="relation-dropdown-header">{{ 'request_v2.links.link_type' | translate }}</div>
          <div class="relation-option"
               [class.selected]="type.value === newLinkType"
               *ngFor="let type of linkTypes"
               (click)="newLinkType = type.value; openDropdownId = null; $event.stopPropagation()">
            <span>{{ type.label | translate }}</span>
            <mat-icon *ngIf="type.value === newLinkType">check</mat-icon>
          </div>
        </div>
      </div>

      <!-- Search input -->
      <div class="search-input-box">
        <mat-icon class="search-icon">search</mat-icon>
        <mat-progress-spinner
          *ngIf="isSearching"
          mode="indeterminate"
          diameter="16"
          class="search-spinner">
        </mat-progress-spinner>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearch($event)"
          [placeholder]="'request_v2.links.search_placeholder' | translate"
          (keydown.escape)="cancelLinking()"
          autofocus>
        <button *ngIf="!isSearching && searchTerm" type="button" class="clear-btn" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="!isSearching && !searchTerm" type="button" class="clear-btn" (click)="cancelLinking()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Floating dropdown -->
    <div class="search-dropdown">
      <button type="button" class="search-option create-option" (click)="createAndLinkRequest()">
        <mat-icon>add</mat-icon>
        <span>{{ 'request_v2.links.create_request' | translate }}</span>
      </button>

      <div class="results-scroll" *ngIf="searchResults.length > 0">
        <button
          type="button"
          class="search-option result-option"
          *ngFor="let res of searchResults"
          (click)="selectRequestToLink(res)">
          <span class="res-id">{{ res.requestId }}</span>
          <span class="res-title">{{ getLinkTitle(res) }}</span>
          <span class="res-status">
            <span class="status-dot" [style.background-color]="getStatus(res)?.color || '#ccc'"></span>
            {{ getStatusLabel(getStatus(res)) }}
          </span>
        </button>
      </div>

      <div class="no-results"
           *ngIf="searchTerm.length >= 2 && searchResults.length === 0 && !isSearching">
        {{ 'request_v2.links.no_results' | translate: { searchTerm: searchTerm } }}
      </div>
    </div>
  </div>

</div>
